"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Divider = _interopRequireDefault(require("../../Divider"));
var _layout = require("../layout.styles");
const _excluded = ["children", "component", "className", "bgColor", "divider", "sticky", "gutters", "yMargin", "yPadding", "fullWidth", "alternatingBackground", "variant"];
/**
 * **❗️ DEPRECATED**: Use the new `ContentBlock` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/layout-contentblock-contentblock):
 *
 * ```tsx
 * import { ContentBlock } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/layout-contentblock-contentblock)
 *
 * @deprecated
 */
const LayoutSection = _ref => {
  let {
      children,
      component: Component = 'div',
      className,
      bgColor,
      divider,
      sticky,
      gutters,
      yMargin,
      yPadding,
      fullWidth = false,
      alternatingBackground = false,
      variant = 'floating'
    } = _ref,
    containerHtmlAttributes = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    cx,
    classes
  } = (0, _layout.useLayoutSectionStyles)({
    bgColor,
    sticky,
    gutters,
    yMargin,
    yPadding,
    fullWidth
  });
  if (!_react.default.Children.toArray(children).length && !divider) return null;
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, containerHtmlAttributes, {
    className: cx('layoutSection', classes.root, classes.responsiveVerticalMargin, classes.responsiveVerticalPadding, {
      [classes.containedVariant]: variant === 'contained',
      [classes.floatingVariant]: variant === 'floating',
      [classes.responsiveStickyPosition]: !!sticky,
      [classes.alternatingBackground]: alternatingBackground
    }, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentWrapper
  }, divider ? /*#__PURE__*/_react.default.createElement(_Divider.default, null) : children));
};
var _default = exports.default = LayoutSection;